export class ProgressModel {
    public currentIndexLabel?: string;
    public currentIndex: number;
    public totalItems: number;
}

export interface ProgressStageModel {
    messages: string[];
    /** When true, the stage messages will repeat a random number of times before advancing. */
    mayLoop?: boolean;
    /** Approximate milliseconds to display each message in this stage (actual duration varies +/-30%). */
    approximateDurationMsPerMessage: number;
}
